export default __webpack_public_path__ + "static/media/07.22a57a76.svg";